import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  createSnackBar = (
    message,
    horizontalPosition,
    verticalPosition,
    duration,
    loadingRequired: boolean = false
  ) => {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message,
        loadingRequired,
      },
      horizontalPosition,
      verticalPosition,
      duration: duration * 1000,
      panelClass: ['notification-bar'],
    });
  };

  dismissSnackbar = () => this.snackBar.dismiss();
}
